// QuestGoal to define what the player needs to do to complete the quest

export class QuestGoal {
    requiredAmount: number;
    currentAmount: number;
    target: string;

    constructor(requiredAmount: number, target: string) {
        this.requiredAmount = requiredAmount;
        this.currentAmount = 0;
        this.target = target;
    }

    /**
     * Updates the progress of the goal
     * @param amount the amount to update the progress by
     */
    updateProgress(amount: number = 1) {
        this.currentAmount += amount;
    }

    /**
     * Checks if the goal has been met
     * @returns true if the goal has been met
     */
    isGoalMet() {
        return this.currentAmount >= this.requiredAmount;
    }
}
